/**
 * Compact flame + count badge for displaying a user's current streak.
 * Renders null when streakCount < 1 so callers need no conditional logic.
 * Used in both the desktop navbar dropdown and the mobile menu header. (ref: DL-007)
 * Flame icon uses amber-500/amber-400 (light/dark) as a documented brand
 * exception distinct from the pink primary accent. (ref: DL-010)
 */
import { cn } from '../client/cn';

type StreakBadgeProps = {
  streakCount: number;
  className?: string;
};

export function StreakBadge({ streakCount, className }: StreakBadgeProps) {
  if (streakCount < 1) {
    return null;
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-base leading-6 font-semibold',
        className,
      )}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        className="text-amber-500 dark:text-amber-400 shrink-0"
      >
        <path d="M13.5 0.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z" />
      </svg>
      <span className="text-neutral-900 dark:text-white">{streakCount}</span>
    </span>
  );
}
